// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IFilterOptionSchema {
  /** Название опции на русском(для вывода на клиент) **/
  displayName: string;
  /** Путь к иконке, иллюстрирующей опцию фильтра **/
  iconUrl?: string;
  /** Название опции на английском **/
  name: EName;
}
export enum EName {
  /** Баня **/
  'Bathhouse' = 'bathhouse',
  /** Год постройки до 2000 года **/
  'BuildYearBefore2000' = 'buildYearBefore2000',
  /** Год постройки c 2000-2009 года **/
  'BuildYearFrom2000To2009' = 'buildYearFrom2000To2009',
  /** Год постройки с 2009-2019 года **/
  'BuildYearFrom2009To2019' = 'buildYearFrom2009To2019',
  /** Год постройки с 2020 года **/
  'BuildYearFrom2020' = 'buildYearFrom2020',
  /** Погреб **/
  'Cellar' = 'cellar',
  /** Можно с детьми **/
  'ChildrenAllowed' = 'childrenAllowed',
  /** Кондиционер **/
  'Conditioner' = 'conditioner',
  /** Парадная после ремонта **/
  'EntranceAfterRepair' = 'entranceAfterRepair',
  /** Есть консьерж в парадной **/
  'EntranceConcierge' = 'entranceConcierge',
  /** Четыре и больше этажей в доме **/
  'FloorCountFourPlus' = 'floorCountFourPlus',
  /** Один этаж в доме **/
  'FloorCountOne' = 'floorCountOne',
  /** Три этажа в доме **/
  'FloorCountThree' = 'floorCountThree',
  /** Два этажа в доме **/
  'FloorCountTwo' = 'floorCountTwo',
  /** Последний этаж **/
  'FloorLast' = 'floorLast',
  /** 1 этаж **/
  'FloorOne' = 'floorOne',
  /** Другой этаж **/
  'FloorOther' = 'floorOther',
  /** 2 этаж **/
  'FloorTwo' = 'floorTwo',
  /** Холодильник **/
  'Fridge' = 'fridge',
  /** Гараж **/
  'Garage' = 'garage',
  /** Кухонная мебель **/
  'KitchenFurniture' = 'kitchenFurniture',
  /** Можно с животными **/
  'PetsAllowed' = 'petsAllowed',
  /** Бассейн **/
  'Pool' = 'pool',
  /** 4 года ремонту **/
  'RepairAgeFour' = 'repairAgeFour',
  /** Больше 5 лет ремонту **/
  'RepairAgeMoreThanFive' = 'repairAgeMoreThanFive',
  /** 1 год ремонту **/
  'RepairAgeOne' = 'repairAgeOne',
  /** 3 года ремонту **/
  'RepairAgeThree' = 'repairAgeThree',
  /** 2 года ремонту **/
  'RepairAgeTwo' = 'repairAgeTwo',
  /** Косметический ремонт **/
  'RepairTypeCosmetic' = 'repairTypeCosmetic',
  /** Дизайнерский ремонт **/
  'RepairTypeDesign' = 'repairTypeDesign',
  /** Евроремонт **/
  'RepairTypeEuro' = 'repairTypeEuro',
  /** Без ремонта **/
  'RepairTypeWithout' = 'repairTypeWithout',
  /** Охрана **/
  'Security' = 'security',
  /** Терраса **/
  'Terrace' = 'terrace',
  /** Телевизор **/
  'Tv' = 'tv',
  /** Блочный дом **/
  'WallMaterialBlock' = 'wallMaterialBlock',
  /** Кирпичный дом **/
  'WallMaterialBrick' = 'wallMaterialBrick',
  /** Монолитный дом **/
  'WallMaterialMonolith' = 'wallMaterialMonolith',
  /** Кирпично-монолитный дом **/
  'WallMaterialMonolithBrick' = 'wallMaterialMonolithBrick',
  /** Панельный дом **/
  'WallMaterialPanel' = 'wallMaterialPanel',
  /** Деревянный дом **/
  'WallMaterialWood' = 'wallMaterialWood',
  /** Стиральная машина **/
  'WashingMachine' = 'washingMachine',
  /** Санузел в доме **/
  'WcTypeLocationIndoor' = 'wcTypeLocationIndoor',
  /** Санузел на улице **/
  'WcTypeLocationOutdoor' = 'wcTypeLocationOutdoor',
}
